/* eslint-disable */
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

let hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    const passiveTestOptions = {
        get passive() {
            hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, passiveTestOptions);
    window.removeEventListener('testPassive', null, passiveTestOptions);
}

const isIosDevice = typeof window !== 'undefined'
    && window.navigator
    && (window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform)
        || window.navigator.platform === 'MacIntel')
        && window.navigator.maxTouchPoints > 1);

const isIos15 = typeof window !== 'undefined'
    && window.navigator
    && window.navigator.userAgent.includes('OS 15');

let documentListenerAdded = false;
let initialClientY = -1;
let previousBodyOverflowSetting;
let previousBodyHeightSetting;
let previousBodyPosition;
let previousBodyPaddingRight;

const preventDefault = function preventDefault(rawEvent) {
    const e = rawEvent || window.event;

    if (e.touches.length > 1) return true;

    if (e.preventDefault) e.preventDefault();

    return false;
};

const setOverflowHidden = function setOverflowHidden(options) {
    if (previousBodyPaddingRight === undefined) {
        const reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

        if (reserveScrollBarGap && scrollBarGap > 0) {
            const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
            previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarGap}px`;
        }
    }

    if (previousBodyOverflowSetting === undefined) {
        previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};

const set100vhHeight = function set100vhHeight(options) {
    if (previousBodyPaddingRight === undefined) {
        const reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

        if (reserveScrollBarGap && scrollBarGap > 0) {
            const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
            previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarGap}px`;
        }
    }

    const scrollY = window.scrollY.valueOf();
    const scrollX = window.scrollX.valueOf();

    if (previousBodyPosition === undefined) {
        previousBodyPosition = {
            top: `${-scrollY}px`,
            left: `${-scrollX}px`
        };
    }

    if (previousBodyOverflowSetting === undefined) {
        previousBodyOverflowSetting = document.body.style.overflow;
        previousBodyHeightSetting = document.body.style.height;
        document.body.style.overflow = 'hidden';
        document.body.style.height = 'calc(100 * var(--vh))';
        document.documentElement.style.overflow = 'hidden';
    }
};

const restoreOverflowSetting = function restoreOverflowSetting() {
    if (previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = previousBodyPaddingRight;
        previousBodyPaddingRight = undefined;
    }

    if (previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = previousBodyOverflowSetting;
        previousBodyOverflowSetting = undefined;
    }
};

const restore100vhHeightSetting = function restore100vhHeightSetting() {
    if (previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = previousBodyPaddingRight;
        previousBodyPaddingRight = undefined;
    }

    if (previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = previousBodyOverflowSetting;
        document.body.style.height = previousBodyHeightSetting;
        document.documentElement.style.overflow = previousBodyOverflowSetting;
        previousBodyOverflowSetting = undefined;
        previousBodyHeightSetting = undefined;
    }

    if (previousBodyPosition !== undefined) {
        const y = -parseInt(previousBodyPosition.top, 10);
        const x = -parseInt(previousBodyPosition.left, 10);

        window.scrollTo(x, y);

        previousBodyPosition = undefined;
    }
};

export const setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(() => {
        // If previousBodyPosition is already set, don't set it again.
        if (previousBodyPosition === undefined) {
            previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };

            // Update the dom inside an animation frame
            const scrollY = window.scrollY.valueOf();
            const scrollX = window.scrollX.valueOf();
            const innerHeight = window.innerHeight.valueOf();

            document.body.style.position = 'fixed';
            document.body.style.top = `${-scrollY}px`;
            document.body.style.left = `${-scrollX}px`;

            setTimeout(() => window.requestAnimationFrame(() => {
                // Attempt to check if the bottom bar appeared due to the position change
                const bottomBarHeight = innerHeight - window.innerHeight;
                if (bottomBarHeight && scrollY >= innerHeight) {
                    // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = `${-(scrollY + bottomBarHeight)}px`;
                }
            }), 300);
        }
    });
};

const restorePositionSetting = function restorePositionSetting() {
    if (previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        const y = -parseInt(document.body.style.top, 10);
        const x = -parseInt(document.body.style.left, 10);

        // Restore styles
        document.body.style.position = previousBodyPosition.position;
        document.body.style.top = previousBodyPosition.top;
        document.body.style.left = previousBodyPosition.left;

        // Restore scroll
        window.scrollTo(x, y);

        previousBodyPosition = undefined;
    }
};

const isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

const findScrollableElement = function findScrollableElement(element) {
    if (element.scrollHeight > element.clientHeight) {
        return element;
    }

    return findScrollableElement(element.parentElement);
};

const handleTouchMove = function touch(rawEvent) {
    const scrollableElement = findScrollableElement(rawEvent.target);
    const clientY = rawEvent.targetTouches[0].clientY - initialClientY;

    if (scrollableElement && scrollableElement.scrollTop === 0 && clientY > 0) {
        return preventDefault(rawEvent);
    }

    if (isTargetElementTotallyScrolled(scrollableElement) && clientY < 0) {
        return preventDefault(rawEvent);
    }

    if (!scrollableElement.hasAttribute('body-scroll-lock-ignore')) {
        return preventDefault(rawEvent);
    }

    rawEvent.stopPropagation();

    return true;
};

const handleTouchStart = function handleTouchStart(event) {
    if (event.targetTouches.length === 1) {
        initialClientY = event.targetTouches[0].clientY;
    }
};

export const disableBodyScroll = function disableBodyScroll(options) {
    if (isIosDevice && !isIos15) {
        setPositionFixed();
    } else if (isIosDevice && isIos15) {
        set100vhHeight(options);
    } else {
        setOverflowHidden(options);
    }

    if (isIosDevice) {
        if (!documentListenerAdded) {
            document.addEventListener('touchmove', handleTouchMove, hasPassiveEvents ? { passive: false } : undefined);
            document.addEventListener('touchstart', handleTouchStart, hasPassiveEvents ? { passive: false } : undefined);
            document.body.addEventListener('touchmove', handleTouchMove, hasPassiveEvents ? { passive: false } : undefined);
            document.body.addEventListener('touchstart', handleTouchStart, hasPassiveEvents ? { passive: false } : undefined);

            documentListenerAdded = true;
        }
    }
};

export const clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
    if (isIosDevice) {
        if (documentListenerAdded) {
            document.removeEventListener('touchmove', handleTouchMove, hasPassiveEvents ? { passive: false } : undefined);
            document.removeEventListener('touchstart', handleTouchStart, hasPassiveEvents ? { passive: false } : undefined);
            document.body.removeEventListener('touchmove', handleTouchMove, hasPassiveEvents ? { passive: false } : undefined);
            document.body.removeEventListener('touchstart', handleTouchStart, hasPassiveEvents ? { passive: false } : undefined);

            documentListenerAdded = false;
        }

        initialClientY = -1;
    }

    if (isIosDevice && !isIos15) {
        restorePositionSetting();
    } else if (isIosDevice && isIos15) {
        restore100vhHeightSetting();
    } else {
        restoreOverflowSetting();
    }
};
